<template lang="pug">
  .expander
    .heading.h4(@click="$emit('update:show', !show)")
      .row
        .col
          slot(name="heading")
          | {{ heading }}
        .col-1
          img(src="../assets/img/expand.svg",:class="{'expanded': show}")
    transition(name="slide")
      .body(v-show="show")
        slot
</template>

<script>
export default {
  name: 'Expander',
  props: {
    heading: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.expander {
  border: 1px solid #d8d8d8;
}
.heading {
  padding: 1rem;
  cursor: pointer;
  vertical-align: middle;
  margin-bottom: 0;
  user-select: none;

  img {
    width: 1rem;
    display: inline-block;
    transition: transform 0.15s;
  }
  img.expanded {
    transform: rotate(180deg);
    transition: transform 0.15s;
  }
}
.body {
  background: #f2f2f2;
  padding: 1rem 3rem;
  max-height: 1000px;
  // overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}
.slide-enter-active,
.slide-leave-active {
  overflow: hidden;
  transition: max-height 0.2s ease;
}
</style>
